import { Api } from 'utils';

class ExcludedPlaceService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/excluded-places/get',params),
		create: async (params?: any) => Api.createResponse('admin/excluded-places/create',params),
		update: async (params?: any) => Api.createResponse('admin/excluded-places/update',params),
		delete: async (params?: any) => Api.createResponse('admin/excluded-places/delete',params),
	}

}

export default ExcludedPlaceService;